import { useEffect, useState } from 'react';
import { useRequest } from '@rahtab/auth/lib/token-based-auth';

export const useGuilds = () => {
  const [guilds, setGuilds] = useState<Guild[]>([]);
  const request = useRequest();
  const [getGuildLoading, setGetGuildLoading] = useState(false);
  useEffect(() => {
    setGetGuildLoading(true);
    request<ServerGuild[]>('GetGuilds')
      .then((guildsData) => {
        const tempGuilds: Guild[] = [];
        guildsData.forEach((guild) => {
          tempGuilds.push({
            label: guild.GuildName,
            value: guild.GuildCode,
          });
        });
        setGuilds(tempGuilds);
      })
      .catch(() => {
        setGetGuildLoading(false);
      });
    setGetGuildLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { getGuildLoading, guilds };
};

export interface Guild {
  label: string;
  value: string;
}

interface ServerGuild {
  GuildCode: string;
  GuildName: string;
}
